module.exports = __webpack_public_path__ + "img/20180101_175406-min.8d01000e.jpg";